module.exports = __webpack_public_path__ + "static/media/tablets.3457b0d4.svg";